var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.tooltip),expression:"tooltip"}],class:_vm.spanClass},[_vm._v(" "+_vm._s(_vm.met)+" / "+_vm._s(_vm.total)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }